export const getFormattedHistory = (history: any): any => {
    if (!history) {
        return ''
    }
    let combinedMessage = '\n';

    history.forEach((message: any) => {
        if (message.type === 'human') {
            combinedMessage += `Human: ${message.content}\n`;
        } else if (message.type === 'ai') {
            combinedMessage += `AI: ${message.content}\n`;
        }
    });

    return combinedMessage;
}

export const getFullDateAndTimeFormatted = () => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    // Create a new Date object for the current date and time
    const currentDate = new Date();

    // Extract day, month, and year
    const day = days[currentDate.getDay()];
    const month = months[currentDate.getMonth()];
    const year = currentDate.getFullYear();

    // Extract time
    // const hours = String(currentDate.getHours()).padStart(2, '0');
    // const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    // const seconds = String(currentDate.getSeconds()).padStart(2, '0');

    // Format the full date and time string
    const formattedDateAndTime = `As of today the Date is ${day} ${currentDate.getDate()} ${month} Year ${year}.`;

    return formattedDateAndTime;
}


export const getAnswerFromResponse = (res: any) => {
    let message = res?.answer ? res?.answer : res?.text
    if(message.startsWith(`"`) && message.endsWith(`"`)){
        message = message.replace(/"/g, '');
    }
    return message;
}

export const getChatHistoryFromResponse = (res: any, session_id: any) => {
    return res['chat_history'] ? res['chat_history'] : res[`chat_history_${session_id}`];
}